<template>
    <div v-if="showModal">
        <div @click="close" :class="modalClass" class="backdrop">
            <div class="card card-outline card-primary card-box mx-auto card--text-modal">

                <div class="card-header">
                    <h3 class="card-title">{{ modalTitle }}</h3>
                    <div class="card-tools">
                        <button type="button"
                                class="btn btn-tool"
                                @click="close"
                        >
                          <i class="fas fa-times"></i>
                        </button>
                    </div>
                </div>

                <div class="modal-card-body">
                    <div v-html="modalText"></div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
export default {
  props: {
    modalTitle: String,
    showModal: Boolean,
    modalText: String,
    modalClass: String
  },
  methods: {
    close() {
      this.$emit('update:showModal', false);
    }
  }
}
</script>

<style scoped>

</style>
